import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {handleSearchAndPage, clearForm, setStore, ValueObjToObj, objToValueObj, findChildren, downLoad} from "../../../../utils/Utils";
import {message} from 'antd'

class researchSbomStore {
    @observable list   //总成散件列表
    @observable loading //列表loading
    @observable pagination //总成散件库分页
    @observable searchFiles //主页面搜索值绑定
    @observable exportModal //导入显示属性
    @observable moveModalVisible //移动模态框显示
    @observable assemblyOrderModalVisible //总成订单模态框显示
    @observable addOrEditModal //新增维护模态框显示
    @observable whichEditModalAction //判断是哪种新增或者维护模态框
    @observable matrialCodeMessage //移动判断物料号是否存在
    @observable editInfo //移动选中行对象
    @observable keyState //当前操作状态，保存key
    @observable searchOrderFields //绑定订单总成
    @observable orderList //绑定订单列表
    @observable orderLoading //订单查询loading
    @observable moveRow //移动行高亮
    @observable carList //车系
    @observable replacementVisible //置换关系模态框
    @observable treeList //置换关系树
    @observable treeIdData //置换关系树根据当前ID查询当前行的数据
    @observable defaultKey //置换关系树默认展开的节点ID
    @observable popoverVisible //置换关系树默认展开的节点ID
    @observable popoverMaterialCode //置换关系树默认展开的节点ID
    @observable relationId //置换关系树默认展开的节点ID
    @observable fileName //导入
    @observable showDrawerEdit
    @observable importReturnEditData
    @observable materialCodeOrPartCodeOrPartName //搜索存值
    @observable carMaterialCode //点击查看实例化用来存放东风零件号
    @observable searchInstantiation //搜索实例化

    //导出
    @observable exportVisible //物料导出
    @observable materialCodeModalKey //判断是物料导出还是车系导出
    @observable carSeriesCode
    @observable materialCode

    //新增及维护
    @observable searchTableFields  //（新增、维护表单绑值 新增总成件，新增同级，新增下级，维护）
    @observable confirmLoading  //确认效果按钮
    @observable isMes  //判断维护中是否来自Mes
    @observable isHaveMaterialCode  //判断物料号是否存在
    @observable addId  //新增ID，选中当前行的ID
    @observable currentLevel  //新增level，选中当前行的level
    @observable currentPid  //，选中当前行的pid

    //epc勾选
    @observable epcCheckVisible //EPC勾选框显示属性
    @observable epcSelectedRowKeys //EPC多选选中数据
    @observable isEpcCheckVisible  //epc勾选是否禁用
    @observable epcCheckValue  //保存epc勾选参数
    @observable epcCarService  //保存车系进入epc勾选
    @observable epcCarCatalog  //车系目录
    @observable epcCatalogId  //车系目录ID
    @observable carseriesId  //车系id
    @observable sendDataToEpc//构建勾选到epc数据  后台需要的值  批量勾选  集合
    @observable epcExpanded//点击展开
    @observable epcLeftLoading//左表loading
    @observable toEpcCarValue//主页面车系Value值绑定
    @observable epcCarValue//epc车系Value值绑定
    @observable epcHighlight//epc车系高亮回显
    @observable modelStatus
    @observable showReplacementRowData
    @observable expandedRowKeys
    @observable style
    @observable amountVal//数量改变时的值
    @observable amountValIndex
    @observable ExportModal   //导入模态框
    @observable editModalTitle    //新增修改模态框
    @observable replacementModal  //置换关系模态框
    @observable checkEPCModal //EPC勾选模态框
    @observable assemblyOrderModal  //查看订单模态框
    @observable selExportModal  //选择导出模态框
    @observable carseriesCodeList   //主界面左边下拉框车系
    @observable rowData
    @observable OneLvCatalogry //左边的一级目录
    @observable isSearch
    @observable carCode   //车系code
    @observable instantiatedCode//实例化号
    @observable level1 //点击左侧目录加层级
    @observable instantiateDoneModal   //导入模态框
    @observable instantiateCode
    @observable instantiateDeleteJudgmentLevel //实例化删除判断层级

    @observable addOrAssemblyEditModal //实例化修改模态框
    @observable editAssemblyFields //实例化修改模态框值绑定

    constructor() {
        this.list = []
        this.OneLvCatalogry = []
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFiles = {
            carSeriesCode: '',
            materialCodeOrPartCodeOrPartName: ''
        }
        this.epcCheckVisible = false
        this.exportModal = false
        this.moveModalVisible = false
        this.assemblyOrderModalVisible = false
        this.addOrEditModal = false
        this.whichEditModalAction = ''
        this.carList = []
        this.searchTableFields = {
            id: '',
            materialCode: '',
            partName: '',
            partCode: '',
            amount: '',
            inEpc: '0',//默认没有被勾选
            pid: '',
            path: '',
            isProcurement: '0',//是否能采购  默认为0  不能采购
            rootMateriaCode: '0',
            level: '',//层级,
            systemId: '',
            carSeriesCode: ''
        }
        this.matrialCodeMessage = false
        this.editInfo = {}
        this.keyState = ''
        this.searchOrderFields = {
            orderNo: '',
            carMaterialCode: ''
        }
        this.orderList = []
        this.orderLoading = false
        this.confirmLoading = false
        this.isMes = false
        this.isHaveMaterialCode = false
        this.isEpcCheckVisible = false
        this.epcCheckValue = []
        this.epcCarService = ''
        this.epcCarCatalog = []
        this.carseriesId = ''
        this.sendDataToEpc = []
        this.epcSelectedRowKeys = []
        this.epcCatalogId = ''
        this.epcExpanded = []
        this.epcLeftLoading = false
        this.toEpcCarValue = ''
        this.epcCarValue = ''
        this.epcHighlight = []
        this.addId = ''
        this.currentLevel = 1
        this.currentPid = ''
        this.moveRow = ''
        this.exportVisible = false
        this.materialCodeModalKey = ''
        this.replacementVisible = false
        this.treeList = []
        this.treeIdData = {}
        this.defaultKey = ''
        this.popoverVisible = false
        this.popoverMaterialCode = ''
        this.relationId = ''
        this.fileName = ''
        this.showDrawerEdit = false
        this.importReturnEditData = []
        this.carSeriesCode = ''
        this.materialCode = ''
        this.modelStatus = false
        this.showReplacementRowData = ''
        this.expandedRowKeys = []
        this.style = false
        this.amountVal = ""
        this.amountValIndex = ""
        this.ExportModal = false
        this.editModalTitle = ''
        this.replacementModal = false
        this.checkEPCModal = false
        this.assemblyOrderModal = false
        this.selExportModal = false
        this.carseriesCodeList = []
        this.rowData = {}
        this.isSearch = false
        this.carCode = ''
        this.materialCodeOrPartCodeOrPartName = ''
        this.carMaterialCode = ''
        this.instantiatedCode = ''
        this.searchInstantiation = ''
        this.level1 = ''
        this.instantiateDoneModal = false
        this.instantiateCode = ''
        this.instantiateDeleteJudgmentLevel = ''

        this.addOrAssemblyEditModal = false
        this.editAssemblyFields = {
            materialCode: '',
            carMaterialCode: '',
            startDate: '',
            deactivationDate: '',
        }
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***搜索表单绑值**/
    @action
    onFormField = (changedFields, fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }

    /****获取车系***/
    @action
    initCarseries = async () => {
        // const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/dongfengCarSeriesDropDownBox`)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/carSeriesUnderPullFrame`)
        runInAction(() => {
            const arr = Array.isArray(res) ? res : []
            this.carList = arr.filter(item=>item.carSeriesCode !=='S32')
        })
    }

    /***左边下拉框搜索框车系数据 ***/
    @action
    initLeftCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/carseries:search`)
        runInAction(() => {
            this.carseriesCodeList = Array.isArray(res) ? res : []
        })
    }

    /** 右侧总成列表**/
    @action
    initPage = async (page) => {
        this.loading = true
        this.searchFiles = {
            carSeriesCode: this.carCode ? this.carCode : '',
            materialCodeOrPartCodeOrPartName: this.materialCodeOrPartCodeOrPartName ? this.materialCodeOrPartCodeOrPartName : '',
            level: this.level1 === 1 ? this.level1 : ''
        }
        let search = handleSearchAndPage(page, this.pagination, this.searchFiles)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res ? findChildren(res.content) : []
            // if (this.isSearch === true) {
            //     this.openTree(res.content)
            // }
            // this.searchFiles.materialCodeOrPartCodeOrPartName &&  this.openTree(res.content)
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.moveRow = this.theMoveRow
            this.isSearch = false
        })
    }

    @action
    openTree = (treeobj) => {
        if (treeobj instanceof Array) {
            treeobj.forEach(item => {
                if (item.path) {
                    this.expandedRowKeys.push(item.path)
                }
                if (item.children) {
                    this.openTree(item.children)
                }
            })
        }
    }

    /*** 总成table选中当前行   系统目录高亮显示*/
    @action
    highlightSystemCatalog = async (value) => {
        this.addId = value.id
        this.currentLevel = value.level
        this.currentPid = value.pid

    }

    /***清空主页面搜索值 ***/
    @action
    clearForms = () => {
        this.searchFiles = {
            ...this.searchFiles,
            materialCodeOrPartCodeOrPartName: '',
            systemId: ''
        }
        this.rowData = {}
        this.style = false
        this.theMoveRow = ''
        this.epcSelectedRowKeys = []
        this.list = []
        this.materialCodeOrPartCodeOrPartName = ''
        // this.initPage()
    }

    /****删除*****/
    @action
    deleteAssembly = async (id) => {
        this.loading = true
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/deleteAll?assemblyId=${id}`)
        runInAction(() => {
            this.loading = false
            message.success('删除成功')
        })
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
    }

    /****显示总成订单***/
    @action
    showAssemblyOrderModal = (item) => {
        this.loading = true
        this.assemblyOrderModalVisible = true
        this.carMaterialCode = item.rootMateriaCode
        this.instantiateDeleteJudgmentLevel = item.level
        this.showOrderList()
        this.loading = false
    }

    /**总成订单列表数据***/
    @action
    showOrderList = async () => {
        this.orderLoading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/mes/dongfengPartNumberQueryInstanceModels`, {
            carMaterialCode: this.carMaterialCode,
            carseriesCode: this.carCode,
            materialCode: this.searchInstantiation
        })
        runInAction(() => {
            this.orderList = res ? res : []
            this.orderLoading = false
        })
    }

    /*******************************EPC勾选*******************************************************/

    /**将勾选总成散件库数据保存,***/
    @action
    saveCheckEpc = (selectedRowKeys, selectedRows) => {
        this.epcCheckValue = []
        // this.epcExpanded=[]
        if (selectedRows.length
            > 0) {
            this.isEpcCheckVisible = true
        } else {
            this.isEpcCheckVisible = false
        }
        this.epcCheckValues = selectedRows
        this.epcSelectedRowKeys = selectedRowKeys
    }

    /**显示epc勾选模态框****/
    @action
    showEpcCheck = async () => {
        this.epcCheckVisible = true
        if (this.toEpcCarValue) {
            this.epcCarValue = this.toEpcCarValue
            let value = this.toEpcCarValue ? this.toEpcCarValue.split('/')[0] : ''
            this.initEpcCarSeries(value)
        } else {
            this.epcCarValue = this.epcCarValue ? this.epcCarValue : ''
        }
    }

    /***获取EPC勾选目录树表*/
    @action
    initEpcCarSeries = async (value) => {
        this.epcLeftLoading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryListByCarCode?carCode=${value}`)
        runInAction(() => {
            this.epcCarCatalog = Array.isArray(res) ? res : []
            this.epcLeftLoading = false
        })
        this.epcHighlightInitData()
    }

    /*** 点击展开图标时触发*/
    @action
    onEpcExpand = (expandedRows) => {
        this.epcExpanded = expandedRows
    }

    /*** 选中车系，车系code+list页面选中行的数据（拿到选中行的rootMCodeList）* 勾选到epc,高亮显示*/
    @action
    epcHighlightInitData = async () => {
        this.rootMaterialCodeList = []
        this.epcCheckValues.forEach((item) => {
            this.rootMaterialCodeList.push(item.rootMateriaCode)
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/system/query/systemlv1/highlight/${this.epcCarService}`, {rootCodeList: this.rootMaterialCodeList})
        runInAction(() => {
            this.epcHighlight = Array.isArray(res) ? res : ''
        })
    }

    /**保留车系目录ID***/
    @action
    saveEpcCatalogId = (record) => {
        this.epcOkButton = false
        this.epcCatalogId = record.id
        this.loading = true
        this.epcCheckValue = this.epcCheckValues
        this.loading = false
    }

    /***保存标号*/
    @action
    doCheckValue = (value, record, index) => {
        this.epcCheckValues[index].grade = value
    }

    /***保存标号*/
    @action
    doCheckAmountValue = (value, record, index) => {
        this.epcCheckValues[index].amount = value
    }

    //保存销售备注
    @action
    doSaleDescription = (value, record, index) => {
        this.epcCheckValues[index].salesDescription = value
    }

    /***保存发送到EPC**/
    @action
    sendToEpc = async () => {
        this.confirmLoading = true
        let sendDataToEpc = this.epcCheckValues.map(item => (
            {
                id: item.id,
                materialCode: item.materialCode,
                carseriesId: this.carseriesId,
                grade: item.grade === undefined ? '' : item.grade,
                catalogId: this.epcCatalogId,
                salesDescription: item.salesDescription,
                amount: item.amount,
            }))
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/check/epc`, sendDataToEpc)
        if (res && res.status === 1) {
            message.success('勾选成功')

        } else {
            runInAction(() => {
                this.confirmLoading = false
            })
            message.error('勾选失败')
            return
        }
        runInAction(() => {
            this.confirmLoading = false
            this.epcCheckVisible = false
            this.epcSelectedRowKeys = []
        })
        this.initPage(this.pagination.current)
    }

    /***关闭epc勾选**/
    @action
    closeEpcCheckModal = () => {
        this.checkEPCModal = false
    }


    /**********************************移动******************************************************/

    /**保存移动选中行参数*****/
    @action
    saveMoveObj = (text) => {
        this.moveModalVisible = true
        this.editInfo = text
        this.moveId = text.id
        this.matrialCodeMessage = true
    }

    /***关闭移动框***/
    @action
    closeMoveModal = () => {
        this.moveModalVisible = false
        this.searchTableFields = {materialCode: ''}
    }

    /***移动，检查根物料号是否存在***/
    @action
    checkMatrialCode = async (code) => {
        this.theMoveRow = code
        this.searchTableFields.materialCode = code
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/materialcode/${this.searchTableFields.materialCode}`)
        if (res && res.status === 0) {
            message.error('您输入的物料号不存在或非MES数据')
            runInAction(() => {
                this.matrialCodeMessage = true
            })
        } else {
            runInAction(() => {
                this.matrialCodeMessage = false
            })
        }
    }

    /*** 移动表单提交*/
    @action
    moveMatrialCode = async () => {
        this.confirmLoading = true
        let search = {
            pid: this.moveId,
            materialCode: this.searchTableFields.materialCode
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/addNext/move/0`, search)
        if (res && res.status === 0) {
            message.warning('移动失败')
        }
        runInAction(() => {
            this.confirmLoading = false
        })
        this.closeMoveModal()
        await this.deleteMoveId()
        this.initPage(this.pagination.current)
    }

    /**移动删除当前id，仅作为后台调用***/
    @action
    deleteMoveId = async () => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/delete/${this.moveId}`)
    }
    /**********************************新增、维护******************************************************/
    /***新增维护表单绑值，包含错误验证，此处不进行转换**/
    @action
    onAddFieldsForm = (changedFields, fields) => {
        this[fields] = {...this[fields], ...changedFields}
    }

    /***关闭新增维护模态框**/
    @action
    closeAddOrEditModal = () => {
        this.addOrEditModal = false
        this.addId = ''
        this.searchTableFields = clearForm(this.searchTableFields)
        this.isMes = false
        this.isHaveMaterialCode = false
    }

    /**保存操作状态，新增或者维护，key,item值***/
    @action
    saveAddOrEditValue = (key, item) => {
        this.keyState = key
        this.editInfo = item
        this.addId = item.id
    }

    /**验证物料编号是否正确***/
    @action
    checkMaterialCode = async (rule, value, callback) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/master/sparepart/verify/${value}`)
        if (res.id) {
            runInAction(() => {
                this.isHaveMaterialCode = false
                this.searchTableFields = {
                    ...this.searchTableFields,
                    partName: objToValueObj(res).partName
                }
            })
            callback()
        } else {
            runInAction(() => {
                this.isHaveMaterialCode = true
                this.searchTableFields = {
                    ...this.searchTableFields,
                    partName: ''
                }
            })
            callback("该零件不存在！")
        }
        callback()
    }

    /**显示新增模态框,保存操作状态***/
    @action
    showAddOrEditModal = (value, item) => {
        if (value !== '3') {
            this.searchTableFields = objToValueObj({amount: 1})
        }
        this.loading = true
        this.whichEditModalAction = value
        this.addOrEditModal = true
        if (value === '3') {
            if (item.isMes === 1) {
                this.isMes = true
            }
            this.searchTableFields = objToValueObj(item)
        }
        this.loading = false
    }

    /***根据保存状态，判断是新增或维护***/
    @action
    saveAddOrEditModal = () => {
        if (this.keyState === '0') {//新增,构造同级
            this.addSameLevel()
        }
        if (this.keyState === '1') {//新增，构造下级
            this.addNextLevel()
        }
        if (this.keyState === '3') {//维护  修改
            this.editSameLevel()
        }
        if (this.whichEditModalAction === 'addAssembly') {  //新增总成
            this.addAssembly()
        }
    }

    /***新增同级***/
    @action
    addSameLevel = async () => {
        this.loading = true
        this.confirmLoading = true
        this.searchTableFields.id = this.addId
        this.searchTableFields.pid = this.currentPid
        this.searchTableFields.level = this.currentLevel
        this.searchTableFields.carSeriesCode = this.searchFiles.carSeriesCode
        this.searchTableFields.amount = this.searchTableFields.amount.value
        this.searchTableFields.materialCode = this.searchTableFields.materialCode.value
        this.searchTableFields.partName = this.searchTableFields.partName.value
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/add/assembly/lv1`, this.searchTableFields)
        if (!res.status) {
            message.warning(res.msg)
        }
        message.success("新增成功")
        runInAction(() => {
            this.keyState = ''
            this.loading = false
            this.confirmLoading = false
            this.addOrEditModal = false
        })
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
        this.closeAddOrEditModal()
    }

    /***新增下级***/
    @action
    addNextLevel = async () => {
        this.loading = true
        this.confirmLoading = true
        let search = {
            masterId: this.editInfo.masterId,
            level: this.editInfo.level,
            pid: this.editInfo.id,
            rootMateriaCode: this.editInfo.rootMateriaCode,
            path: this.editInfo.path,
            amount: this.searchTableFields.amount.value,
            materialCode: this.searchTableFields.materialCode.value,
            partName: this.searchTableFields.partName.value,
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/addNext/move/1`, search)
        if (!res.status) {
            message.warning(res.msg)
        }
        message.success("新增成功")
        runInAction(() => {
            this.keyState = ''
            this.loading = false
            this.confirmLoading = false
            this.addOrEditModal = false
        })
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
        this.closeAddOrEditModal()
    }

    /***维护**/
    @action
    editSameLevel = async () => {
        this.loading = true
        this.confirmLoading = true
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/master/sparepart`, ValueObjToObj(this.searchTableFields))
        runInAction(() => {
            this.keyState = ''
            this.loading = false
            this.confirmLoading = false
            this.addOrEditModal = false
        })
        message.success("数据维护成功")
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
        this.closeAddOrEditModal()
    }

    /***新增总成,当没有选中车系和系统目录时候，新增，只在总成散件库中。2:当选中车系和目录时，与车系相关*/
    @action
    addAssembly = async () => {
        this.loading = true
        this.confirmLoading = true
        let search = {
            amount: this.searchTableFields.amount.value,
            level: 1,
            materialCode: this.searchTableFields.materialCode.value,
            partName: this.searchTableFields.partName.value,
            carSeriesCode: this.carCode,
            systemId: this.searchFiles.systemId ? this.searchFiles.systemId : ''
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/add/assembly/lv1`, search)
        if (res.status === 0) {
            message.warning(res.msg)
            runInAction(() => {
                this.keyState = ''
                this.loading = false
                this.confirmLoading = false
                this.addOrEditModal = false
            })
            this.closeAddOrEditModal()
        } else {
            runInAction(() => {
                this.keyState = ''
                this.loading = false
                this.confirmLoading = false
                this.addOrEditModal = false
            })
            this.closeAddOrEditModal()
            this.initPage(this.pagination.current)
            this.getOneLvCatalogry(this.carCode)
        }
    }

    /****导出***/
    @action
    openExportModal = (key) => {
        this.materialCodeModalKey = key
        this.exportVisible = true
    }

    /**批量导出***/
    @action
    batchExport = () => {
        let ids = this.epcSelectedRowKeys.toString().replace(/\//g, '').split(',')
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/exportByIds?ids=${ids}`, '批量导出.xls')
        message.warning('正在导出中，请耐心等待！');
    }

    //显示置换关系
    @action
    showReplacement = async (text) => {
        this.treeList = []
        this.loading = true
        this.showReplacementRowData = text
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/relationShip/search/id/${text.id}`)
        runInAction(() => {
            if (res.status === 0) {
                this.treeList = []
            } else {
                this.treeList.push(res)
                this.treeIdData = this.findArr(this.treeList, text.id)
                this.relationId = this.treeIdData.relationId
                this.defaultKey = this.treeIdData.id
            }
            this.replacementVisible = true
            this.loading = false
        })
    }

    @action
    findArr = (arr, id) => {
        arr.forEach(item => {
            if (item.id === id) {
                this.treeIdData = item
            }
            this.treeIdData = this.findArr(item.children, id)
        })
        return this.treeIdData
    }

    //通过车系拿一级目录
    @action
    getOneLvCatalogry = async (e) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/carSeriesQueryAssemblyName?carseriesCode=${e}`)
        runInAction(() => {
            this.OneLvCatalogry = Array.isArray(res) ? res : []
        })
    }

    //关联置换关系
    @action
    relationReplacement = async () => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/relationShip/add/id/${this.treeIdData.id}/materialCode/${this.popoverMaterialCode} `)
        runInAction(() => {
            if (!res.status) {
                message.warning(res.msg)
            } else {
                message.success('关联成功')
                this.popoverMaterialCode = ''
                this.popoverVisible = false
                // this.closeReplacement()
                this.replacementModal = false
                this.showReplacement(this.showReplacementRowData)
                this.initPage(this.pagination.current)
            }
        })
    }

    //删除置换关系
    @action
    deleteReplacement = async () => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/relationShip/delete/id/${this.treeIdData.id}`)
        runInAction(() => {
            if (res.status) {
                message.success('删除成功')
            }
            this.closeReplacement()
            this.initPage(this.pagination.current)
            this.modelStatus = true
        })
    }

    //关闭置换关系
    @action
    closeReplacement = () => {
        this.replacementModal = false
        this.treeList = []
    }

    @action
    deleteAllClickData = async (text) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/deleteChildren/id/${text.id}`)
        runInAction(() => {
            if (res.status) {
                message.success('删除所有下级成功')
            }
            this.initPage(this.pagination.current)
            this.getOneLvCatalogry(this.carCode)
        })
    }

    /**实例化删除**/
    @action
    onInstantiateCode = async () => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/instantiateDelete?carCode=${this.carCode}&instantiateCode=${this.instantiateCode}`)
        runInAction(() => {
            if (res.status) {
                message.success('删除成功')
            }
            this.instantiateDoneModal = false
            this.OneLvCatalogry = []
            this.list = []
            this.instantiateCode = ''
        })
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
    }


    /**东风零件号和整车物料号删除**/
    @action
    dongfengPartNumberDeleted = async (carMaterialCode) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assembly/deleteRootMaterialNumberAndVehicleMaterialNumber?carCode=${this.carCode}&rootMaterialCode=${this.carMaterialCode}&carMaterialCode=${carMaterialCode}`)
        runInAction(() => {
            if (res.status) {
                message.success('删除成功')
            }
            this.assemblyOrderModal = false
            this.OneLvCatalogry = []
            this.list = []
        })
        this.initPage(this.pagination.current)
        this.getOneLvCatalogry(this.carCode)
    }


    /***关闭实例化修改模态框**/
    @action
    closeAddOrAssemblyEditModal = () => {
        this.addOrAssemblyEditModal = false
        this.addId = ''
        this.editAssemblyFields = clearForm(this.editAssemblyFields)
        this.confirmLoading = false
    }


    /***保存实例化修改模态框**/
    @action
    saveAddOrAssemblyEditModal = async () => {
        this.confirmLoading = true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/mes/changeTheInstantiationPrimaryDate`, ValueObjToObj(this.editAssemblyFields))
        runInAction(() => {
            if (res.status) {
                message.success("数据维护成功")
            }
            this.showOrderList()
            this.closeAddOrAssemblyEditModal()
        })
    }


    /***维护**/
    @action
    editAssemblyEditModal = async (record) => {
        runInAction(() => {
            this.editAssemblyFields = objToValueObj({materialCode:this.editInfo.materialCode,...record})
            this.addOrAssemblyEditModal = true
        })

    }
}

export default new researchSbomStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sbom/ResearchSBOM/store.js